import { API_BASE_URL } from '../../config/api';
import apiCache, { CACHE_TTL } from '../../lib/apiCache';

const CACHE_KEY = 'clubes';

const ClubesData = {
    fetch: async () => {
        const cached = apiCache.get(CACHE_KEY);
        if (cached !== undefined) return cached;

        try {
            const response = await fetch(`${API_BASE_URL}/api/clubes`);
            const data = await response.json();

            if (data.message === "No hay clubes registrados") {
                return apiCache.set(CACHE_KEY, data, CACHE_TTL.LIST);
            }

            // If data is a single object, wrap it in an array
            const clubesArray = Array.isArray(data.clubes) ? data.clubes : [data.clubes];
            
            const result = clubesArray.map(club => ({
                id: club.clubcodigo,
                nombre: club.clubnombre,
                logo: club.logo,
                clubasociado: club.clubasociado,
                clubfax: club.clubfax
            }));
            return apiCache.set(CACHE_KEY, result, CACHE_TTL.LIST);
        } catch (error) {
            console.error('Error fetching clubes:', error);
            return { message: "Error al cargar los clubes" };
        }
    },
};

export default ClubesData;
